import React from "react";
import Image from "gatsby-image";
import { ArticlePhotos } from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  return {
    date: "21.04.2020r",
    category:
      "kampanie marketingowe, kryzys marketing odpowiedzialny społecznie",
    title: "Kampanie w dobie koronawirusa",
    description: (
      <>
        Za nami ciężkie tygodnie walki z pandemią, która stanowi sprawdzian nie
        tylko dla polityków, służby zdrowia czy przedsiębiorstw, ale również
        jest wyzwaniem dla całej branży marketingu. Po czasie niepokoju,
        zaskoczenia, a czasem nawet i przestoju, wychodzi słońce i wszyscy uczą
        się funkcjonować w tej całkiem nowej rzeczywistości. Agencje reklamowe i
        PR-owe – a co za tym idzie, ich klienci – również.
      </>
    ),
    seo:
      "Za nami ciężkie tygodnie walki z pandemią, która stanowi sprawdzian nie tylko dla polityków",
    slug: "/blog/kampanie_w_dobie_koronawirusa",
    hero: (
      <Image
        alt=""
        objectPosition={"center"}
        objectFit={"contain"}
        fluid={images.hero.childImageSharp.fluid}
      />
    ),
    text: {
      first: {
        title: "",
        text: (
          <>
            Niektóre marki zareagowały błyskawicznie, są też takie, które
            włączają dopiero teraz temat koronawirusa do swoich przekazów, a
            jeszcze inne w ogóle ignorują ten wątek. Poniższy przegląd
            podzieliliśmy wg branż, dobierając co ciekawsze kampanie i
            działania.
          </>
        ),
      },
      second: {
        title: "Pomoc innym a walka o przetrwanie",
        text: (
          <>
            Zamknięte restauracje, bary, puby i hotele oznaczają dla właścicieli
            ogromne straty. Te lokale, które mogły, uruchomiły dostarczanie
            posiłków na wynos. Wiele z nich również zaangażowało się w akcję
            #gastropomaga czy „Wzywamy posiłki”, dostarczając darmowe dania do
            szpitali. Powstała również inicjatywa #bezpiecznedowozy zrzeszająca
            restauracje i dostawców jedzenia, którzy zobowiązali się do
            przestrzegania i promowania Kodeksu Dobrych Praktyk. Ma on na celu
            zagwarantowanie, że posiłki są przygotowywane i dostarczane w sposób
            bezpieczny dla wszystkich osób zaangażowanych: obsługę restauracji,
            kurierów oraz klientów. W powyższe akcje zaangażowani nie tylko
            znane firmy jak McDonalds, Costa Coffee, Pizza Hut, Sphinx czy
            Makarun, ale również wiele lokalnie działających punktów
            gastronomicznych.
          </>
        ),
      },
      third: {
        title: "",
        text: (
          <>
            Niektóre kluby, puby czy hotele rozpoczęły sprzedaż voucherów
            online, które będą mogły zostać wykorzystane po wycofaniu obostrzeń,
            a teraz mają zapewnić ich właścicielom płynność finansową.
          </>
        ),
      },
      fourth: {
        title: "Piękni medycy, dotacje i żele antybakteryjne",
        text: (
          <>
            Branża beauty również stawia na pomoc i działania w zakresie
            marketingu społecznego. Wybija się tutaj marka Dove, która zręcznie
            pogodziła swoją długofalową kampanię „Real Beauty” z ekstremalną
            sytuacją, w jakiej się znaleźliśmy. Za pomocą spotu zatytułowanego
            „Courage is beautiful” („Odwaga jest piękna”), firma złożyła swoisty
            hołd wszystkim pracownikom służby zdrowia. W klipie przewijają się
            zdjęcia amerykańskich medyków po pracy – zmęczonych, opuchniętych,
            ze śladami i siniakami po noszeniu sprzętu ochronnego. Firma
            przekazała również 2 miliony dolarów na zakup środków ochrony
            osobistej dla służby zdrowia w Stanach Zjednoczonych.
          </>
        ),
      },
      fifth: {
        title: "",
        text: (
          <>
            Koncern L'Oreal z kolei zawiesił działania reklamowe w telewizji.
            Firma wdrożyła własny ogólnoeuropejski program solidarnościowy, w
            ramach którego wspomoże m.in. partnerskie szpitale, domy opieki,
            apteki i salony fryzjerskie. W fabrykach L'Oreal trwa również
            produkcja środków dezynfekujących dla potrzeb francuskich i
            europejskich organów służby zdrowia.
          </>
        ),
      },
      sixth: {
        title: "Przebranżowienie i darmowe przewozy",
        text: (
          <>
            To kolejna branża, która mocno ucierpiała na skutek koronawirusa.
            Nie dziwi więc, że marka Bolt odpowiadająca za aplikację
            umożliwiającą zamówienie przewozu, poszła w ślady konkurencji i na
            wzór Uber Eats w Warszawie zadebiutował Bolt Food. Kierowcy
            zatrudnieni przez firmę mogą nie tylko wozić ludzi, ale również
            dostarczać posiłki.
          </>
        ),
      },
      seventh: {
        title: "",
        text: (
          <>
            Tutaj jednak również można spotkać przykłady marketingu
            odpowiedzialnego społecznie. Wspomniany już Uber wraz z Free Now
            oferują darmowe przejazdy dla pracowników służby zdrowia i
            laboratoriów medycznych. Co ważne, kierowcy obu firm otrzymają pełne
            wypłaty za kursy wykonane w ramach tych akcji.
          </>
        ),
      },
      eighth: {
        title: "",
        text: (
          <>
            Różne marki na swój sposób zareagowały na trwającą pandemię.
            Coca-Cola całkowicie zrezygnowała z reklam, niektórzy, tak jak Agata
            Meble, przekazali dotacje dla służby zdrowia, zaś - przykładowo -
            sieci sklepów spożywczych w komunikacji stawiają na podziękowanie
            pracownikom. To, co łączy te wszystkie działania, to
            odpowiedzialność społeczna i poleganie na swoim wizerunku. Od niego
            będzie zależało, czy klienci np. nabędą vouchery albo nadal będą
            kupować dane produkty. To pokazuje, jak ważne są działania
            długofalowe, nastawione na konsumenta, a nie na czysty zysk.
            Marketing jeszcze nigdy nie był tak życzliwy jak w obecnych czasach.
          </>
        ),
      },
    },
    images: {
      first: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_1.childImageSharp.fluid}
        />
      ),
      second: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_2.childImageSharp.fluid}
        />
      ),
      third: (
        <Image
          alt=""
          objectPosition={"center"}
          objectFit={"contain"}
          fluid={images.img_3.childImageSharp.fluid}
        />
      ),
    },
  };
};
